<div class="info-row">
  <div class="info-row_label">
    <img *ngIf="labelIconLink" [src]="labelIconLink" alt="">
    <span>{{label | allLettersCapital}}</span>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <div *ngIf="link; else defaultValue">
      <a [href]="link"  class="info-row_value info-row_link" ngbTooltip="Go to Dealership details page">{{value && (value + '').trim() ? (value + '').trim() : noValuePlaceholder}}</a>
    </div>
    
    <ng-template #defaultValue>
      <div class="info-row_value">{{value && (value + '').trim() ? (value + '').trim() : noValuePlaceholder}}</div>
    </ng-template>
  </ng-container>
</div>

<ng-template #loading>
  <ngx-skeleton-loader
    appearance="line"
    [theme]="{'height': '18px', 'margin':'0px','width':'100%', 'min-width':'120px'}">
  </ngx-skeleton-loader>
</ng-template>
